import { reportResizeHandleClass } from "./report-table-presentation.js";

export function ReportColumnResizeHandle({
  label,
  onResizeStart,
}: {
  label: string;
  onResizeStart: (clientX: number) => void;
}): React.JSX.Element {
  return (
    <button
      type="button"
      aria-label={label}
      data-testid="report-column-resize"
      className={`pointer-fine:block hidden ${reportResizeHandleClass}`}
      onPointerDown={(event) => {
        event.preventDefault();
        event.stopPropagation();
        onResizeStart(event.clientX);
      }}
    />
  );
}
